import React, { useState } from "react";
import { FaArrowRightLong, FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import { emailicon, messageicon } from "../../../assets/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useMutation } from "@tanstack/react-query";
import useSnackbar from "../../../hooks/useSnackbar";
import { AuthService } from "../../../services";
import { numberLoginValidation } from "../../../validations/auth";
import { joiResolver } from "@hookform/resolvers/joi";
import { useForm } from "react-hook-form";
import useUser from "../../../hooks/useUser";
import ButtonLoader from "../../../component/buttonLoader";

const Number = () => {
  const { setUser } = useUser();
  const navigate = useNavigate();
  const { snackbar } = useSnackbar();
  const { login } = AuthService();
  const [changePassword, setChangePassword] = useState(true);
  const changeIcon = !changePassword;
  const location = useLocation();
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: joiResolver(numberLoginValidation),
    defaultValues: {
      countryCode: "",
      mobile: "",
      password: ""
    }
  });
  // ---------redirect-page----------------
  function handleLoginSuccess() {
    const redirectPath = location.state?.from === "/healthplan"
      ? "/healthplan"
      : "/";
    navigate(redirectPath);
  }
  const sendOtpMutation = useMutation({
    mutationFn: data => login({ ...data, deviceType: "web", deviceToken: "dummy" }),
    onSuccess: (data) => {
      localStorage.setItem("hollypills_token", data?.data?.token);
      setUser(data?.data?.user);
      snackbar((data?.message || ""), "info");
      // navigate("/");
      handleLoginSuccess();
    },
    onError: (err) => {
      snackbar((err.data.message || ""));
    }
  });


  return (
    <>
      <form onSubmit={handleSubmit(sendOtpMutation.mutate)}>
        <div className="form_field">
          <label className="label" htmlFor="">
            Mobile Number
          </label>
          <PhoneInput
            country={"in"}
            placeholder="Enter Number"
            onChange={(fullNumber, dialCodeDetail) => {
              const mobile = fullNumber.replace(`${dialCodeDetail?.dialCode}`, "");
              const countryCode = dialCodeDetail?.dialCode;
              setValue("mobile", mobile);
              setValue("countryCode", countryCode);
            }}
          />
          {errors.mobile?.message && <span className="error">{errors.mobile?.message}</span>}
        </div>
        <div className="form_field icon_set">
          <label className="label" htmlFor="">
            Password
          </label>
          <input
            type={changePassword ? "password" : "text"}
            className="input form-control"
            placeholder="Enter Your Password..."
            {...register("password")}
          />
          <span
            onClick={() => {
              setChangePassword(changeIcon);
            }}
          >
            {changeIcon ? <FaRegEyeSlash /> : <FaRegEye />}
          </span>
          <img src={emailicon} alt="icon" />
          {errors.password?.message && <span className="error">{errors.password?.message}</span>}
          {/* <span className="error">Please fill correct mail</span> */}
        </div>
        <div className="btn_wrap_login">
          <ButtonLoader
            text={<>Log In <FaArrowRightLong /></>}
            className="login"
            isLoading={sendOtpMutation.isPending}
          />
        </div>
      </form>
      <div className="account_signup">
        <p>
          Already have an account ? <Link to={"/signup"}> Sign Up. </Link>
        </p>
        <p>
          <Link to={"/forgot"}> Forgot your password? </Link>
        </p>
      </div>
    </>
  );
};

export default Number;
